var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" },
      [
        _c(
          "c-card",
          { staticClass: "cardClassDetailInfo", attrs: { noHeader: true } },
          [
            _c("template", { slot: "card-detail" }, [
              _c(
                "div",
                { staticClass: "col-3" },
                [
                  _c("c-label-text", {
                    attrs: { title: "사업장", value: _vm.param.plantName },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-3" },
                [
                  _c("c-label-text", {
                    attrs: {
                      title: "설비유형",
                      value: _vm.param.equipmentTypeName,
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-3" },
                [
                  _c("c-label-text", {
                    attrs: {
                      title: "설비관리번호",
                      value: _vm.param.equipmentNo,
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-3" },
                [
                  _c("c-label-text", {
                    attrs: { title: "설비명", value: _vm.param.equipmentName },
                  }),
                ],
                1
              ),
            ]),
          ],
          2
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" },
      [
        _c(
          "c-table",
          {
            ref: "grid",
            attrs: {
              title: "설비 사양",
              tableId: "grid",
              columns: _vm.grid.columns,
              data: _vm.grid.data,
              selection: "multiple",
              rowKey: "equipmentSpecId",
              isFullScreen: false,
              columnSetting: false,
              filtering: false,
            },
          },
          [
            _c(
              "template",
              { slot: "table-button" },
              [
                _c(
                  "q-btn-group",
                  { attrs: { outline: "" } },
                  [
                    _vm.editable
                      ? _c("c-btn", {
                          attrs: { label: "추가", icon: "add" },
                          on: { btnClicked: _vm.addrow },
                        })
                      : _vm._e(),
                    _vm.editable
                      ? _c("c-btn", {
                          attrs: { label: "저장", icon: "save" },
                          on: { btnClicked: _vm.saveSpec },
                        })
                      : _vm._e(),
                    _vm.editable
                      ? _c("c-btn", {
                          attrs: { label: "삭제", icon: "remove" },
                          on: { btnClicked: _vm.deleteSpec },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }